import React from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import '../components/css/BlogStyle.css';


function privacyPolicy(){
    return(
        <>
            <HeaderTop />
            <Navbar />
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">Privacy Policy</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <div class="container my-5">
                <div class="row g-4">
                    <div class="col-lg-12">
                        <h3>Privacy Policy</h3>
                        <p>Vigyan Vriksh is a structured institution complete in all aspects which provides quality education for IIT-JAM, UGC-CSIR-NET, GATE and other M.Sc. Entrance exams. . This document is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.</p>
                        <p>If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in the Term and Conditions.</p>
                        <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Vigyan Vriksh unless otherwise defined in the Term and Conditions.</p>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default privacyPolicy;